import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateExercise, getExercise } from "../apis/exercisesApi";
import { STORAGE_BASE_URL } from "../config/api";
import Swal from "sweetalert2";
import BackgroundSelector from "../components/BackgroundSelector";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faCaretDown, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "../styles.css";

library.add(faCircleArrowLeft, faCaretDown, faTrash);

const UpdateForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showBackgroundSelector, setShowBackgroundSelector] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(-1);
  const [errorField, setErrorField] = useState(null);
  const [exerciseData, setExerciseData] = useState({
    name: "",
    help_image: null,
    background_image_path: null,
    consigne: "",
    consigne_audio: null,
    song_audio: null,
    type: "",
    fonttype: "",
    per_link: "",
    isfrench: false,
    isarabic: false,
    fr1: "",
    questions: [],
  });
  const [backgroundImageFile, setBackgroundImageFile] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [questionData, setQuestionData] = useState({
    T1: "",
    T2: "",
    T3: "",
    T4: "",
    T5: "",
    T6: "",
    T7: "",
    T9: "",
    fr1: "",
    table4: null,
    hmed_audio: null,
    Isac_audio: null,
    reponse: "",
    reponse1: "",
    reponse2: "",
    phrase_finale: "",
  });
  const [questionFiles, setQuestionFiles] = useState(
    Array(6)
      .fill()
      .map(() => ({ table4: null, hmed_audio: null, Isac_audio: null }))
  );

  const helpImageRef = useRef(null);
  const consigneAudioRef = useRef(null);
  const songAudioRef = useRef(null);
  const table4Ref = useRef(null);
  const hmedAudioRef = useRef(null);
  const IsacAudioRef = useRef(null);
  const backgroundImageRef = useRef(null);
  const selectRef = useRef(null);
  const fonttypeSelectRef = useRef(null);

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB for regular files
const MAX_BACKGROUND_SIZE = 50 * 1024 * 1024; // 50MB for background images
const MAX_TABLE4_SIZE = 10 * 1024 * 1024; // 2MB for table4 images
  const MAX_QUESTIONS = 6;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const exercise = await getExercise(id);
        setExerciseData({
          name: exercise.name || "",
          help_image: exercise.help_image || null,
          background_image_path: exercise.background_image || null,
          consigne: exercise.consigne || "",
          consigne_audio: exercise.consigne_audio ? exercise.consigne_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
          song_audio: exercise.song_audio ? exercise.song_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
          type: exercise.type || "",
          fonttype: exercise.fonttype || "",
          per_link: exercise.per_link || "",
          isfrench: exercise.isfrench || false,
          isarabic: exercise.isarabic || false,
          fr1: exercise.fr1 || "",
          questions: exercise.questions || [],
        });

        const fetchedQuestions = exercise.questions || [];
        const limitedQuestions = fetchedQuestions.slice(0, MAX_QUESTIONS);
        const paddedQuestions = limitedQuestions
          .concat(
            Array(Math.max(0, MAX_QUESTIONS - limitedQuestions.length))
              .fill()
              .map(() => ({
                T1: "",
                T2: "",
                T3: "",
                T4: "",
                T5: "",
                T6: "",
                T7: "",
                T9: "",
                fr1: "",
                table4: null,
                hmed_audio: null,
                Isac_audio: null,
                reponse: "",
                reponse1: "",
                reponse2: "",
                phrase_finale: "",
              }))
          )
          .map((q) => ({
            T1: q.T1 || "",
            T2: q.T2 || "",
            T3: q.T3 || "",
            T4: q.T4 || "",
            T5: q.T5 || "",
            T6: q.T6 || "",
            T7: q.T7 || "",
            T9: q.T9 || "",
            fr1: q.fr1 || "",
            table4: q.table4 || null,
            hmed_audio: q.hmed_audio ? q.hmed_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
            Isac_audio: q.Isac_audio ? q.Isac_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
            reponse: q.reponse || "",
            reponse1: q.reponse1 || "",
            reponse2: q.reponse2 || "",
            phrase_finale: q.phrase_finale || "",
          }));
        setQuestions(paddedQuestions);
        setQuestionFiles(
          Array(MAX_QUESTIONS)
            .fill()
            .map(() => ({ table4: null, hmed_audio: null, Isac_audio: null }))
        );
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(t("updateForm.errorExercise"));
        setLoading(false);
      }
    };
    fetchData();
  }, [id, t]);

  const handleRetry = () => {
    setLoading(true);
    setError(null);
    const fetchData = async () => {
      try {
        const exercise = await getExercise(id);
        setExerciseData({
          name: exercise.name || "",
          help_image: exercise.help_image || null,
          background_image_path: exercise.background_image || null,
          consigne: exercise.consigne || "",
          consigne_audio: exercise.consigne_audio ? exercise.consigne_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
          song_audio: exercise.song_audio ? exercise.song_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
          type: exercise.type || "",
          fonttype: exercise.fonttype || "",
          per_link: exercise.per_link || "",
          isfrench: exercise.isfrench || false,
          isarabic: exercise.isarabic || false,
          fr1: exercise.fr1 || "",
          questions: exercise.questions || [],
        });

        const fetchedQuestions = exercise.questions || [];
        const limitedQuestions = fetchedQuestions.slice(0, MAX_QUESTIONS);
        const paddedQuestions = limitedQuestions
          .concat(
            Array(Math.max(0, MAX_QUESTIONS - limitedQuestions.length))
              .fill()
              .map(() => ({
                T1: "",
                T2: "",
                T3: "",
                T4: "",
                T5: "",
                T6: "",
                T7: "",
                T9: "",
                fr1: "",
                table4: null,
                hmed_audio: null,
                Isac_audio: null,
                reponse: "",
                reponse1: "",
                reponse2: "",
                phrase_finale: "",
              }))
          )
          .map((q) => ({
            T1: q.T1 || "",
            T2: q.T2 || "",
            T3: q.T3 || "",
            T4: q.T4 || "",
            T5: q.T5 || "",
            T6: q.T6 || "",
            T7: q.T7 || "",
            T9: q.T9 || "",
            fr1: q.fr1 || "",
            table4: q.table4 || null,
            hmed_audio: q.hmed_audio ? q.hmed_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
            Isac_audio: q.Isac_audio ? q.Isac_audio.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '') : null,
            reponse: q.reponse || "",
            reponse1: q.reponse1 || "",
            reponse2: q.reponse2 || "",
            phrase_finale: q.phrase_finale || "",
          }));
        setQuestions(paddedQuestions);
        setQuestionFiles(
          Array(MAX_QUESTIONS)
            .fill()
            .map(() => ({ table4: null, hmed_audio: null, Isac_audio: null }))
        );
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data on retry:", err);
        setError(t("updateForm.errorExercise"));
        setLoading(false);
      }
    };
    fetchData();
  };

  const handleExerciseChange = (e) => {
  const { name, value, files, type, checked } = e.target;
  setErrorField((prev) => (prev === name ? null : prev));
  if (files && (name === "help_image" || name === "consigne_audio" || name === "song_audio" || name === "background_image")) {
    const file = files[0];
    if (!file) return;

    // Separate size validation for background images (50MB) vs other files (10MB)
    if (name === "background_image") {
      if (file.size > 50 * 1024 * 1024) { // Changed to 50MB
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fileTooLarge", { size: 50 }), // Changed size parameter to 50
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        e.target.value = null;
        backgroundImageRef.current.value = null;
        return;
      }
    } else {
      if (file.size > MAX_FILE_SIZE) { // Other files still 10MB
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fileTooLarge", { size: 10 }),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        e.target.value = null;
        if (name === "help_image") helpImageRef.current.value = null;
        else if (name === "consigne_audio") consigneAudioRef.current.value = null;
        else if (name === "song_audio") songAudioRef.current.value = null;
        else backgroundImageRef.current.value = null;
        return;
      }
    }

    if (
      (name === "help_image" || name === "background_image") &&
      !["image/jpeg", "image/png", "image/jpg", "image/gif"].includes(file.type)
    ) {
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t(`updateForm.invalidImageType.${name === "help_image" ? "help" : "background"}`),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      e.target.value = null;
      if (name === "help_image") helpImageRef.current.value = null;
      else backgroundImageRef.current.value = null;
      return;
    }

    if ((name === "consigne_audio" || name === "song_audio") && file.type !== "audio/wav") {
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t(`updateForm.invalidAudioType.${name === "consigne_audio" ? "consigne" : "song"}`),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      e.target.value = null;
      if (name === "consigne_audio") consigneAudioRef.current.value = null;
      else if (name === "song_audio") songAudioRef.current.value = null;
      return;
    }

    if (name === "background_image") {
      setBackgroundImageFile(file);
      setExerciseData((prev) => ({ ...prev, background_image_path: null }));
    } else {
      setExerciseData((prev) => ({ ...prev, [name]: file }));
    }
  } else if (type === "checkbox" && name === "isfrench") {
    setExerciseData((prev) => ({
      ...prev,
      isfrench: checked,
      isarabic: checked ? false : prev.isarabic
    }));
  } else if (type === "checkbox" && name === "isarabic") {
    setExerciseData((prev) => ({
      ...prev,
      isarabic: checked,
      isfrench: checked ? false : prev.isfrench
    }));
  } else {
    setExerciseData((prev) => ({ ...prev, [name]: value || "" }));
  }
};

  const handleBackgroundSelect = (path) => {
    setExerciseData((prev) => ({
      ...prev,
      background_image_path: path,
    }));
    setBackgroundImageFile(null);
    setShowBackgroundSelector(false);
    Swal.fire({
      title: t("common.success"),
      text: t("updateForm.success.backgroundSelected"),
      icon: "success",
      confirmButtonColor: "var(--primary-color)",
      background: "var(--card-background)",
    });
  };

  const handleDeleteFile = (type) => {
    if (type === "help_image") {
      setExerciseData((prev) => ({ ...prev, help_image: null }));
      helpImageRef.current.value = null;
    } else if (type === "background_image") {
      setExerciseData((prev) => ({ ...prev, background_image_path: null }));
      setBackgroundImageFile(null);
      if (backgroundImageRef.current) backgroundImageRef.current.value = null;
    } else if (type === "table4") {
      setQuestionFiles((prev) => {
        const updated = [...prev];
        updated[currentQuestionIndex] = {
          ...updated[currentQuestionIndex],
          table4: null,
        };
        return updated;
      });
      setQuestionData((prev) => ({ ...prev, table4: null }));
      table4Ref.current.value = null;
    } else if (type === "consigne_audio") {
      setExerciseData((prev) => ({ ...prev, consigne_audio: null }));
      consigneAudioRef.current.value = null;
    } else if (type === "song_audio") {
      setExerciseData((prev) => ({ ...prev, song_audio: null }));
      songAudioRef.current.value = null;
    } else if (type === "hmed_audio") {
      setQuestionFiles((prev) => {
        const updated = [...prev];
        updated[currentQuestionIndex] = {
          ...updated[currentQuestionIndex],
          hmed_audio: null,
        };
        return updated;
      });
      setQuestionData((prev) => ({ ...prev, hmed_audio: null }));
      hmedAudioRef.current.value = null;
    } else if (type === "Isac_audio") {
      setQuestionFiles((prev) => {
        const updated = [...prev];
        updated[currentQuestionIndex] = {
          ...updated[currentQuestionIndex],
          Isac_audio: null,
        };
        return updated;
      });
      setQuestionData((prev) => ({ ...prev, Isac_audio: null }));
      IsacAudioRef.current.value = null;
    }
    Swal.fire({
      title: t("common.success"),
      text: t("updateForm.success.fileDeleted"),
      icon: "success",
      confirmButtonColor: "var(--primary-color)",
      background: "var(--card-background)",
    });
  };

  const handleQuestionChange = (e) => {
    const { name, value, files } = e.target;
    setErrorField((prev) => (prev === name ? null : prev));
    if (files && (name === "table4" || name === "hmed_audio" || name === "Isac_audio")) {
      const file = files[0];
      if (!file) return;
      const maxSize = name === "table4" ? MAX_TABLE4_SIZE : MAX_FILE_SIZE;
      if (file.size > maxSize) {
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fileTooLarge", { size: maxSize / (1024 * 1024) }),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        e.target.value = null;
        if (name === "table4") table4Ref.current.value = null;
        else if (name === "hmed_audio") hmedAudioRef.current.value = null;
        else IsacAudioRef.current.value = null;
        return;
      }
      if (
        name === "table4" &&
        !["image/jpeg", "image/png", "image/jpg", "image/gif"].includes(file.type)
      ) {
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.invalidImageType.table4"),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        e.target.value = null;
        table4Ref.current.value = null;
        return;
      }
      if ((name === "hmed_audio" || name === "Isac_audio") && file.type !== "audio/wav") {
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t(`updateForm.invalidAudioType.${name === "hmed_audio" ? "hmed" : "isac"}`),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        e.target.value = null;
        if (name === "hmed_audio") hmedAudioRef.current.value = null;
        else IsacAudioRef.current.value = null;
        return;
      }
      setQuestionFiles((prev) => {
        const updated = [...prev];
        updated[currentQuestionIndex] = {
          ...updated[currentQuestionIndex],
          [name]: file,
        };
        return updated;
      });
      setQuestionData((prev) => ({ ...prev, [name]: file }));
    } else {
      setQuestionData((prev) => ({ ...prev, [name]: value || "" }));
    }
  };

  const handleFonttypeIconClick = () => {
    if (fonttypeSelectRef.current) {
      fonttypeSelectRef.current.focus();
      fonttypeSelectRef.current.click();
    }
  };

  const handleIconClick = () => {
    if (selectRef.current) {
      selectRef.current.focus();
      selectRef.current.click();
    }
  };

  const markFieldError = (fieldName) => {
    setErrorField(fieldName);
    requestAnimationFrame(() => {
      const el = document.querySelector(`[name="${fieldName}"]`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  };

  // Maps an internal field name (as returned by validateCurrentQuestion) to a
  // human-readable, translated label for use in error messages.
  const getFieldLabel = (fieldName) => {
    switch (fieldName) {
      case "name":
        return t("updateForm.exerciseName");
      case "type":
        return t("updateForm.exerciseType");
      case "fonttype":
        return t("updateForm.fontType");
      case "T1":
        return t("updateForm.choice1");
      case "T2":
        return t("updateForm.choice2");
      case "T3":
        return t("updateForm.choice3");
      case "T4":
        return t("updateForm.choice4");
      case "T5":
        return t("updateForm.choice5");
      case "T6":
        return t("updateForm.choice6");
      case "T7":
        return exerciseData.type === "clavier_maths"
          ? t("updateForm.mathExpression")
          : t("updateForm.phrase");
      case "T9":
        return t("updateForm.correctPhrase");
      case "fr1":
        return t("updateForm.frenchPhrase");
      case "reponse":
        return t("updateForm.correctChoice");
      case "reponse1":
        return t("updateForm.firstCorrectAnswer");
      case "reponse2":
        return t("updateForm.secondCorrectAnswer");
      default:
        return fieldName;
    }
  };

  // Returns the name of the first missing/invalid required field for the
  // current question type, or null when the question is valid.
  const validateCurrentQuestion = () => {
    const needFr1 = !exerciseData.isfrench && !exerciseData.isarabic;
    if (exerciseData.type === "clavier_maths") {
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.reponse.trim()) return "reponse";
    } else if (exerciseData.type === "clavier_langue") {
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "clavier2inputs") {
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.reponse1.trim()) return "reponse1";
      if (!questionData.reponse2.trim()) return "reponse2";
    } else if (exerciseData.type === "quizz") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.T9.trim()) return "T9";
      if (!questionData.reponse.trim()) return "reponse";
    } else if (exerciseData.type === "click") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "click_3_choix") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "click_4_choix") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.T4.trim()) return "T4";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "click_phrase") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.T9.trim()) return "T9";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "click_3_phrase") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.T9.trim()) return "T9";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "click_4_phrase") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.T4.trim()) return "T4";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.T9.trim()) return "T9";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "dropbox") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.reponse.trim()) return "reponse";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "dropbox_langue") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.reponse.trim()) return "reponse";
      if (!questionData.fr1.trim()) return "fr1";
    } else if (exerciseData.type === "drag_and_drop_phrase" || exerciseData.type === "drag_and_drop_paragraphe") {
      if (!questionData.T1.trim()) return "T1";
      if (!questionData.T2.trim()) return "T2";
      if (!questionData.T3.trim()) return "T3";
      if (!questionData.T4.trim()) return "T4";
      if (!questionData.T5.trim()) return "T5";
      if (!questionData.T6.trim()) return "T6";
      if (!questionData.T7.trim()) return "T7";
      if (!questionData.T9.trim()) return "T9";
      if (needFr1 && !questionData.fr1.trim()) return "fr1";
    }
    return null;
  };

  const handleNext = () => {
    setErrorField(null);
    if (currentQuestionIndex === -1) {
      if (!exerciseData.name.trim()) {
        markFieldError("name");
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.nameRequired"),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        return;
      }
      if (!exerciseData.type) {
        markFieldError("type");
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.typeRequired"),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        return;
      }
      if (!exerciseData.fonttype) {
        markFieldError("fonttype");
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fontTypeRequired"),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        return;
      }
      const firstQuestion = questions[0];
      setQuestionData({
        T1: firstQuestion.T1 || "",
        T2: firstQuestion.T2 || "",
        T3: firstQuestion.T3 || "",
        T4: firstQuestion.T4 || "",
        T5: firstQuestion.T5 || "",
        T6: firstQuestion.T6 || "",
        T7: firstQuestion.T7 || "",
        T9: firstQuestion.T9 || "",
        fr1: firstQuestion.fr1 || "",
        table4: firstQuestion.table4 || null,
        hmed_audio: firstQuestion.hmed_audio || null,
        Isac_audio: firstQuestion.Isac_audio || null,
        reponse: firstQuestion.reponse || "",
        reponse1: firstQuestion.reponse1 || "",
        reponse2: firstQuestion.reponse2 || "",
        phrase_finale: firstQuestion.phrase_finale || "",
      });
      setCurrentQuestionIndex(0);
    } else if (currentQuestionIndex < MAX_QUESTIONS - 1) {
      const missingField = validateCurrentQuestion();
      if (missingField) {
        markFieldError(missingField);
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fieldRequired", { field: getFieldLabel(missingField) }),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        return;
      }
      const updatedQuestions = questions.map((q, index) =>
        index === currentQuestionIndex ? { ...questionData } : q
      );
      setQuestions(updatedQuestions);
      setExerciseData((prev) => ({ ...prev, questions: updatedQuestions }));

      const nextQuestion = updatedQuestions[currentQuestionIndex + 1];
      setQuestionData({
        T1: nextQuestion.T1 || "",
        T2: nextQuestion.T2 || "",
        T3: nextQuestion.T3 || "",
        T4: nextQuestion.T4 || "",
        T5: nextQuestion.T5 || "",
        T6: nextQuestion.T6 || "",
        T7: nextQuestion.T7 || "",
        T9: nextQuestion.T9 || "",
        fr1: nextQuestion.fr1 || "",
        table4: nextQuestion.table4 || null,
        hmed_audio: nextQuestion.hmed_audio || null,
        Isac_audio: nextQuestion.Isac_audio || null,
        reponse: nextQuestion.reponse || "",
        reponse1: nextQuestion.reponse1 || "",
        reponse2: nextQuestion.reponse2 || "",
        phrase_finale: nextQuestion.phrase_finale || "",
      });
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handleBack = () => {
    setErrorField(null);
    if (currentQuestionIndex > 0) {
      const updatedQuestions = questions.map((q, index) =>
        index === currentQuestionIndex ? { ...questionData } : q
      );
      setQuestions(updatedQuestions);
      setExerciseData((prev) => ({ ...prev, questions: updatedQuestions }));

      const prevQuestion = updatedQuestions[currentQuestionIndex - 1];
      setQuestionData({
        T1: prevQuestion.T1 || "",
        T2: prevQuestion.T2 || "",
        T3: prevQuestion.T3 || "",
        T4: prevQuestion.T4 || "",
        T5: prevQuestion.T5 || "",
        T6: prevQuestion.T6 || "",
        T7: prevQuestion.T7 || "",
        T9: prevQuestion.T9 || "",
        fr1: prevQuestion.fr1 || "",
        table4: prevQuestion.table4 || null,
        hmed_audio: prevQuestion.hmed_audio || null,
        Isac_audio: prevQuestion.Isac_audio || null,
        reponse: prevQuestion.reponse || "",
        reponse1: prevQuestion.reponse1 || "",
        reponse2: prevQuestion.reponse2 || "",
        phrase_finale: prevQuestion.phrase_finale || "",
      });
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    } else if (currentQuestionIndex === 0) {
      const updatedQuestions = questions.map((q, index) =>
        index === currentQuestionIndex ? { ...questionData } : q
      );
      setQuestions(updatedQuestions);
      setExerciseData((prev) => ({ ...prev, questions: updatedQuestions }));
      setCurrentQuestionIndex(-1);
    }
  };

 const handleSave = async () => {
  try {
    setIsSubmitting(true);
    setErrorField(null);

    // Validate required fields
    if (!exerciseData.name.trim()) {
      markFieldError("name");
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t("updateForm.nameRequired"),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      setIsSubmitting(false);
      return;
    }
    if (!exerciseData.type) {
      markFieldError("type");
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t("updateForm.typeRequired"),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      setIsSubmitting(false);
      return;
    }
    if (!exerciseData.fonttype) {
      markFieldError("fonttype");
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t("updateForm.fontTypeRequired"),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      setIsSubmitting(false);
      return;
    }

    let updatedQuestions = [...questions];
    if (currentQuestionIndex >= 0) {
      const missingField = validateCurrentQuestion();
      if (missingField) {
        markFieldError(missingField);
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fieldRequired", { field: getFieldLabel(missingField) }),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        setIsSubmitting(false);
        return;
      }
      updatedQuestions = questions.map((q, index) =>
        index === currentQuestionIndex ? { ...questionData } : q
      );
      setQuestions(updatedQuestions);
      setExerciseData((prev) => ({ ...prev, questions: updatedQuestions }));
    }

    const formData = new FormData();
    formData.append("name", exerciseData.name.trim());
    if (exerciseData.consigne) formData.append("consigne", exerciseData.consigne);
    formData.append("type", exerciseData.type);
    formData.append("fonttype", exerciseData.fonttype);
    if (exerciseData.per_link) formData.append("per_link", exerciseData.per_link.trim());
    formData.append("isfrench", exerciseData.isfrench ? "1" : "0");
    formData.append("isarabic", exerciseData.isarabic ? "1" : "0");

    // Always append current value for help_image (file or string path or empty)
    formData.append("help_image", exerciseData.help_image instanceof File
      ? exerciseData.help_image
      : (exerciseData.help_image || ""));

    // Background handling (unchanged, as it already covers cases)
    if (backgroundImageFile instanceof File) {
      formData.append("background_image", backgroundImageFile);
    } else if (exerciseData.background_image_path) {
      formData.append("background_image_path", exerciseData.background_image_path);
    } else {
      formData.append("background_image_path", "");
    }

    // Always append current value for consigne_audio (file or string path or empty)
    formData.append("consigne_audio", exerciseData.consigne_audio instanceof File
      ? exerciseData.consigne_audio
      : (exerciseData.consigne_audio || ""));

    // Always append current value for song_audio (file or string path or empty)
    formData.append("song_audio", exerciseData.song_audio instanceof File
      ? exerciseData.song_audio
      : (exerciseData.song_audio || ""));

    // Loop over all questions and always append all relevant fields (text as || "", files/paths as computed value)
    updatedQuestions.forEach((question, index) => {
      // T1 (always for non-math/langue types)
      if (exerciseData.type !== "clavier_maths" &&
          exerciseData.type !== "clavier_langue" &&
          exerciseData.type !== "clavier2inputs") {
        formData.append(`questions[${index}][T1]`, question.T1 || "");
      }

      // T2 (for types that support it)
      if (exerciseData.type === "click" ||
          exerciseData.type === "click_3_choix" ||
          exerciseData.type === "click_4_choix" ||
          exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe" ||
          exerciseData.type === "quizz" ||
          exerciseData.type === "click_phrase") {
        formData.append(`questions[${index}][T2]`, question.T2 || "");
      }

      // T3 (for types that support it)
      if (exerciseData.type === "click_3_choix" ||
          exerciseData.type === "click_4_choix" ||
          exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T3]`, question.T3 || "");
      }

      // T4 (for types that support it)
      if (exerciseData.type === "click_4_choix" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T4]`, question.T4 || "");
      }

      // T5 (for drag types)
      if (exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T5]`, question.T5 || "");
      }

      // T6 (for drag types)
      if (exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T6]`, question.T6 || "");
      }

      // T7 (for types that support it)
      if (exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "click_phrase" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe" ||
          exerciseData.type === "clavier_maths" ||
          exerciseData.type === "clavier_langue" ||
          exerciseData.type === "clavier2inputs" ||
          exerciseData.type === "quizz") {
        formData.append(`questions[${index}][T7]`, question.T7 || "");
      }

      // T9 (for types that support it)
      if (exerciseData.type === "click_phrase" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe" ||
          exerciseData.type === "clavier2inputs" ||
          exerciseData.type === "quizz") {
        formData.append(`questions[${index}][T9]`, question.T9 || "");
      }

      // fr1 (conditional based on type and language flags)
      if (exerciseData.type === "dropbox_langue" ||
          (!exerciseData.isfrench && !exerciseData.isarabic &&
            (exerciseData.type === "dropbox" ||
             exerciseData.type === "clavier_langue" ||
             exerciseData.type === "click" ||
             exerciseData.type === "click_3_choix" ||
             exerciseData.type === "click_4_choix" ||
             exerciseData.type === "click_phrase" ||
             exerciseData.type === "click_3_phrase" ||
             exerciseData.type === "click_4_phrase" ||
             exerciseData.type === "drag_and_drop_phrase"))) {
        formData.append(`questions[${index}][fr1]`, question.fr1 || "");
      }

      // table4: Always append current (file or path or empty)
      const table4Value = questionFiles[index]?.table4 instanceof File
        ? questionFiles[index].table4
        : (question.table4 || "");
      formData.append(`questions[${index}][table4]`, table4Value);

      // hmed_audio: Always append current (file or path or empty)
      const hmedValue = questionFiles[index]?.hmed_audio instanceof File
        ? questionFiles[index].hmed_audio
        : (question.hmed_audio || "");
      formData.append(`questions[${index}][hmed_audio]`, hmedValue);

      // Isac_audio: Always append current (file or path or empty)
      const isacValue = questionFiles[index]?.Isac_audio instanceof File
        ? questionFiles[index].Isac_audio
        : (question.Isac_audio || "");
      formData.append(`questions[${index}][Isac_audio]`, isacValue);

      // reponse handling
      if (exerciseData.type === "clavier2inputs") {
        formData.append(`questions[${index}][reponse1]`, question.reponse1 || "");
        formData.append(`questions[${index}][reponse2]`, question.reponse2 || "");
        formData.append(`questions[${index}][phrase_finale]`, question.phrase_finale || "");
      } else {
        formData.append(`questions[${index}][reponse]`, question.reponse || "");
      }
    });

    const formDataObj = {};
    for (let [key, value] of formData.entries()) {
      formDataObj[key] = value instanceof File ? `File: ${value.name}` : value;
    }
    console.log("Sending FormData (Save):", formDataObj);
    console.log("isfrench value sent:", formDataObj["isfrench"]);
    console.log("isarabic value sent:", formDataObj["isarabic"]);

    const response = await updateExercise(id, formData);

    console.log("Save response:", response);

    if (response.exercise) {
      Swal.fire({
        title: t("common.success"),
        text: t("updateForm.success.exerciseUpdated"),
        icon: "success",
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      navigate("/");
    } else {
      throw new Error(response.message || t("updateForm.unexpectedResponse"));
    }
  } catch (err) {
    console.error("Error saving exercise:", {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
    });
    Swal.fire({
      icon: "error",
      title: t("common.error"),
      text: err.response?.data?.message || err.message || t("updateForm.updateFailed"),
      html: err.response?.data?.errors
        ? `<p>${err.response.data.message}</p><ul>${Object.entries(
            err.response.data.errors
          )
            .map(([key, messages]) =>
              messages.map((msg) => `<li>${key}: ${msg}</li>`).join("")
            )
            .join("")}</ul>`
        : err.response?.data?.message || err.message || t("updateForm.updateFailed"),
      confirmButtonColor: "var(--primary-color)",
      background: "var(--card-background)",
    });
  } finally {
    setIsSubmitting(false);
  }
};

  const handleSaveAndFinish = async () => {
  try {
    setIsSubmitting(true);
    setErrorField(null);

    // Validate required fields
    if (!exerciseData.name.trim()) {
      markFieldError("name");
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t("updateForm.nameRequired"),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      setIsSubmitting(false);
      return;
    }
    if (!exerciseData.type) {
      markFieldError("type");
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t("updateForm.typeRequired"),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      setIsSubmitting(false);
      return;
    }
    if (!exerciseData.fonttype) {
      markFieldError("fonttype");
      Swal.fire({
        icon: "error",
        title: t("common.error"),
        text: t("updateForm.fontTypeRequired"),
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      setIsSubmitting(false);
      return;
    }

    let updatedQuestions = [...questions];
    if (currentQuestionIndex >= 0) {
      const missingField = validateCurrentQuestion();
      if (missingField) {
        markFieldError(missingField);
        Swal.fire({
          icon: "error",
          title: t("common.error"),
          text: t("updateForm.fieldRequired", { field: getFieldLabel(missingField) }),
          confirmButtonColor: "var(--primary-color)",
          background: "var(--card-background)",
        });
        setIsSubmitting(false);
        return;
      }
      updatedQuestions = questions.map((q, index) =>
        index === currentQuestionIndex ? { ...questionData } : q
      );
      setQuestions(updatedQuestions);
      setExerciseData((prev) => ({ ...prev, questions: updatedQuestions }));
    }

    const formData = new FormData();
    formData.append("name", exerciseData.name.trim());
    if (exerciseData.consigne) formData.append("consigne", exerciseData.consigne);
    formData.append("type", exerciseData.type);
    formData.append("fonttype", exerciseData.fonttype);
    if (exerciseData.per_link) formData.append("per_link", exerciseData.per_link.trim());
    formData.append("isfrench", exerciseData.isfrench ? "1" : "0");
    formData.append("isarabic", exerciseData.isarabic ? "1" : "0");

    // Always append current value for help_image (file or string path or empty)
    formData.append("help_image", exerciseData.help_image instanceof File
      ? exerciseData.help_image
      : (exerciseData.help_image || ""));

    // Background handling (unchanged, as it already covers cases)
    if (backgroundImageFile instanceof File) {
      formData.append("background_image", backgroundImageFile);
    } else if (exerciseData.background_image_path) {
      formData.append("background_image_path", exerciseData.background_image_path);
    } else {
      formData.append("background_image_path", "");
    }

    // Always append current value for consigne_audio (file or string path or empty)
    formData.append("consigne_audio", exerciseData.consigne_audio instanceof File
      ? exerciseData.consigne_audio
      : (exerciseData.consigne_audio || ""));

    // Always append current value for song_audio (file or string path or empty)
    formData.append("song_audio", exerciseData.song_audio instanceof File
      ? exerciseData.song_audio
      : (exerciseData.song_audio || ""));

    // Filter valid questions (keep this from original, but apply fixes in the loop below)
    const validQuestions = updatedQuestions.filter((q) =>
      exerciseData.type === "clavier_maths" || exerciseData.type === "clavier_langue"
        ? q.T7.trim() && q.reponse.trim()
        : exerciseData.type === "clavier2inputs"
        ? q.T7.trim() && q.reponse1.trim() && q.reponse2.trim()
        : exerciseData.type === "quizz"
        ? q.T1.trim() && q.T2.trim() && q.T7.trim() && q.T9.trim() && q.reponse.trim()
        : exerciseData.type === "click"
        ? q.T1.trim() && q.T2.trim() && q.reponse.trim()
        : exerciseData.type === "click_3_choix"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.reponse.trim()
        : exerciseData.type === "click_4_choix"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.T4.trim() && q.reponse.trim()
        : exerciseData.type === "click_phrase"
        ? q.T1.trim() && q.T2.trim() && q.T7.trim() && q.T9.trim() && q.reponse.trim()
        : exerciseData.type === "click_3_phrase"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.T7.trim() && q.T9.trim() && q.reponse.trim()
        : exerciseData.type === "click_4_phrase"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.T4.trim() && q.T7.trim() && q.T9.trim() && q.reponse.trim()
        : exerciseData.type === "dropbox"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.T7.trim() && q.reponse.trim()
        : exerciseData.type === "dropbox_langue"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.T7.trim() && q.reponse.trim() && q.fr1.trim()
        : exerciseData.type === "drag_and_drop_phrase" || exerciseData.type === "drag_and_drop_paragraphe"
        ? q.T1.trim() && q.T2.trim() && q.T3.trim() && q.T4.trim() && q.T5.trim() && q.T6.trim() && q.T7.trim() && q.T9.trim()
        : q.T1.trim() && q.reponse.trim()
    );

    // Loop over valid questions and always append all relevant fields (text as || "", files/paths as computed value)
    validQuestions.forEach((question, index) => {
      // T1 (always for non-math/langue types)
      if (exerciseData.type !== "clavier_maths" &&
          exerciseData.type !== "clavier_langue" &&
          exerciseData.type !== "clavier2inputs") {
        formData.append(`questions[${index}][T1]`, question.T1 || "");
      }

      // T2 (for types that support it)
      if (exerciseData.type === "click" ||
          exerciseData.type === "click_3_choix" ||
          exerciseData.type === "click_4_choix" ||
          exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe" ||
          exerciseData.type === "quizz" ||
          exerciseData.type === "click_phrase") {
        formData.append(`questions[${index}][T2]`, question.T2 || "");
      }

      // T3 (for types that support it)
      if (exerciseData.type === "click_3_choix" ||
          exerciseData.type === "click_4_choix" ||
          exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T3]`, question.T3 || "");
      }

      // T4 (for types that support it)
      if (exerciseData.type === "click_4_choix" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T4]`, question.T4 || "");
      }

      // T5 (for drag types)
      if (exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T5]`, question.T5 || "");
      }

      // T6 (for drag types)
      if (exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe") {
        formData.append(`questions[${index}][T6]`, question.T6 || "");
      }

      // T7 (for types that support it)
      if (exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "click_phrase" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe" ||
          exerciseData.type === "clavier_maths" ||
          exerciseData.type === "clavier_langue" ||
          exerciseData.type === "clavier2inputs" ||
          exerciseData.type === "quizz") {
        formData.append(`questions[${index}][T7]`, question.T7 || "");
      }

      // T9 (for types that support it)
      if (exerciseData.type === "click_phrase" ||
          exerciseData.type === "click_3_phrase" ||
          exerciseData.type === "click_4_phrase" ||
          exerciseData.type === "dropbox" ||
          exerciseData.type === "dropbox_langue" ||
          exerciseData.type === "drag_and_drop_phrase" ||
          exerciseData.type === "drag_and_drop_paragraphe" ||
          exerciseData.type === "clavier2inputs" ||
          exerciseData.type === "quizz") {
        formData.append(`questions[${index}][T9]`, question.T9 || "");
      }

      // fr1 (conditional based on type and language flags)
      if (exerciseData.type === "dropbox_langue" ||
          (!exerciseData.isfrench && !exerciseData.isarabic &&
            (exerciseData.type === "dropbox" ||
             exerciseData.type === "clavier_langue" ||
             exerciseData.type === "click" ||
             exerciseData.type === "click_3_choix" ||
             exerciseData.type === "click_4_choix" ||
             exerciseData.type === "click_phrase" ||
             exerciseData.type === "click_3_phrase" ||
             exerciseData.type === "click_4_phrase" ||
             exerciseData.type === "drag_and_drop_phrase"))) {
        formData.append(`questions[${index}][fr1]`, question.fr1 || "");
      }

      // table4: Always append current (file or path or empty)
      const table4Value = questionFiles[index]?.table4 instanceof File
        ? questionFiles[index].table4
        : (question.table4 || "");
      formData.append(`questions[${index}][table4]`, table4Value);

      // hmed_audio: Always append current (file or path or empty)
      const hmedValue = questionFiles[index]?.hmed_audio instanceof File
        ? questionFiles[index].hmed_audio
        : (question.hmed_audio || "");
      formData.append(`questions[${index}][hmed_audio]`, hmedValue);

      // Isac_audio: Always append current (file or path or empty)
      const isacValue = questionFiles[index]?.Isac_audio instanceof File
        ? questionFiles[index].Isac_audio
        : (question.Isac_audio || "");
      formData.append(`questions[${index}][Isac_audio]`, isacValue);

      // reponse handling
      if (exerciseData.type === "clavier2inputs") {
        formData.append(`questions[${index}][reponse1]`, question.reponse1 || "");
        formData.append(`questions[${index}][reponse2]`, question.reponse2 || "");
        formData.append(`questions[${index}][phrase_finale]`, question.phrase_finale || "");
      } else {
        formData.append(`questions[${index}][reponse]`, question.reponse || "");
      }
    });

    const formDataObj = {};
    for (let [key, value] of formData.entries()) {
      formDataObj[key] = value instanceof File ? `File: ${value.name}` : value;
    }
    console.log("Sending FormData (Save And Finish):", formDataObj);

    const response = await updateExercise(id, formData);

    console.log("Update response:", response);

    if (response.exercise) {
      Swal.fire({
        title: t("common.success"),
        text: t("updateForm.success.exerciseUpdated"),
        icon: "success",
        confirmButtonColor: "var(--primary-color)",
        background: "var(--card-background)",
      });
      navigate("/");
    } else {
      throw new Error(response.message || t("updateForm.unexpectedResponse"));
    }
  } catch (err) {
    console.error("Error updating exercise:", {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
    });
    Swal.fire({
      icon: "error",
      title: t("common.error"),
      text: err.response?.data?.message || err.message || t("updateForm.updateFailed"),
      html: err.response?.data?.errors
        ? `<p>${err.response.data.message}</p><ul>${Object.entries(
            err.response.data.errors
          )
            .map(([key, messages]) =>
              messages.map((msg) => `<li>${key}: ${msg}</li>`).join("")
            )
            .join("")}</ul>`
        : err.response?.data?.message || err.message || t("updateForm.updateFailed"),
      confirmButtonColor: "var(--primary-color)",
      background: "var(--card-background)",
    });
  } finally {
    setIsSubmitting(false);
  }
};

  const handleBackToExercises = () => {
    navigate("/");
  };

  const UploadIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="update-form-upload-icon"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  );

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path instanceof File) {
      return URL.createObjectURL(path);
    }
    const cleanPath = path.startsWith(STORAGE_BASE_URL)
      ? path.replace(STORAGE_BASE_URL, '').replace(/^\/+/, '')
      : path;
    if (cleanPath.startsWith("http")) {
      return cleanPath;
    }
    return `${STORAGE_BASE_URL}/${cleanPath}`;
  };

  if (loading) {
    return (
      <div className="update-form-overlay">
        <div className="update-form-container update-form-status-container">
          <p>{t("updateForm.loadingExercise")}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="update-form-overlay">
        <div className="update-form-container update-form-status-container">
          <p>{error}</p>
          <button onClick={handleRetry} className="update-form-button">
            {t("common.retry")}
          </button>
        </div>
      </div>
    );
  }

  const isExerciseScreen = currentQuestionIndex === -1;

  return (
    <div className="update-form-overlay">
      <div className="update-form-container">
        <div className="update-form-header">
          <button
            type="button"
            onClick={handleBackToExercises}
            className="update-form-back-button"
            title={t("updateForm.backToExercises")}
          >
            <FontAwesomeIcon
              icon="fa-solid fa-circle-arrow-left"
              className="update-form-back-icon"
            />
          </button>
          <h2 className="update-form-title">
            {isExerciseScreen
              ? t("updateForm.title", { name: exerciseData.name || id })
              : t("updateForm.questionTitle", {
                  number: currentQuestionIndex + 1,
                  total: MAX_QUESTIONS,
                  name: exerciseData.name || id,
                })}
          </h2>
        </div>
        <div className="update-form-steps">
          <span
            className={`update-form-step-dot${
              isExerciseScreen ? " update-form-step-dot-active" : " update-form-step-dot-done"
            }`}
            title={t("updateForm.exerciseDetailsSection")}
          />
          {Array.from({ length: MAX_QUESTIONS }).map((_, idx) => (
            <span
              key={idx}
              className={`update-form-step-dot${
                currentQuestionIndex === idx
                  ? " update-form-step-dot-active"
                  : currentQuestionIndex > idx
                  ? " update-form-step-dot-done"
                  : ""
              }`}
              title={t("updateForm.questionTitle", {
                number: idx + 1,
                total: MAX_QUESTIONS,
                name: exerciseData.name || id,
              })}
            />
          ))}
        </div>
        <div className="update-form-content">
          {isExerciseScreen ? (
            <div className="exercise-section">
              <h3 className="update-form-section-heading">{t("updateForm.exerciseDetailsSection")}</h3>
              <div>
                <label className="update-form-field-label">{t("updateForm.exerciseType")}</label>
                <div className={`update-form-custom-select-container${errorField === "type" ? " update-form-error" : ""}`}>
                  <span className="update-form-custom-select-text">
                    {exerciseData?.type
                      ? t(`updateForm.types.${exerciseData.type}`)
                      : t("updateForm.selectExerciseType")}
                  </span>
                  <FontAwesomeIcon
                    icon="fa-solid fa-caret-down"
                    className="update-form-caret-icon"
                    onClick={handleIconClick}
                  />
                  <select
                    name="type"
                    value={exerciseData?.type || ""}
                    onChange={handleExerciseChange}
                    ref={selectRef}
                    className="update-form-custom-select"
                  >
                    <option value="" disabled>
                      {t("updateForm.selectExerciseType")}
                    </option>
                    <option value="dropbox">{t("updateForm.types.dropbox")}</option>
                    <option value="dropbox_langue">{t("updateForm.types.dropbox_langue")}</option>
                    <option value="click">{t("updateForm.types.click")}</option>
                    <option value="click_3_choix">{t("updateForm.types.click_3_choix")}</option>
                    <option value="click_4_choix">{t("updateForm.types.click_4_choix")}</option>
                    <option value="click_phrase">{t("updateForm.types.click_phrase")}</option>
                    <option value="click_3_phrase">{t("updateForm.types.click_3_phrase")}</option>
                    <option value="click_4_phrase">{t("updateForm.types.click_4_phrase")}</option>
                    <option value="drag_and_drop_phrase">{t("updateForm.types.drag_and_drop_phrase")}</option>
                    <option value="drag_and_drop_paragraphe">{t("updateForm.types.drag_and_drop_paragraphe")}</option>
                    <option value="clavier_maths">{t("updateForm.types.clavier_maths")}</option>
                    <option value="clavier_langue">{t("updateForm.types.clavier_langue")}</option>
                    <option value="clavier2inputs">{t("updateForm.types.clavier2inputs")}</option>
                    <option value="quizz">{t("updateForm.types.quizz")}</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="update-form-field-label">{t("updateForm.fontType")}</label>
                <div className={`update-form-custom-select-container${errorField === "fonttype" ? " update-form-error" : ""}`}>
                  <span className="update-form-custom-select-text">
                    {exerciseData?.fonttype
                      ? t(`updateForm.font${exerciseData.fonttype.charAt(0).toUpperCase()}${exerciseData.fonttype.slice(1)}`)
                      : t("updateForm.selectFontType")}
                  </span>
                  <FontAwesomeIcon
                    icon="fa-solid fa-caret-down"
                    className="update-form-caret-icon"
                    onClick={handleFonttypeIconClick}
                  />
                  <select
                    name="fonttype"
                    value={exerciseData?.fonttype || ""}
                    onChange={handleExerciseChange}
                    ref={fonttypeSelectRef}
                    className="update-form-custom-select"
                  >
                    <option value="" disabled>
                      {t("updateForm.selectFontType")}
                    </option>
                    <option value="small">{t("updateForm.fontSmall")}</option>
                    <option value="medium">{t("updateForm.fontMedium")}</option>
                    <option value="large">{t("updateForm.fontLarge")}</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="update-form-field-label" htmlFor="update-form-name">{t("updateForm.exerciseName")}</label>
                <input
                  id="update-form-name"
                  type="text"
                  name="name"
                  value={exerciseData.name}
                  onChange={handleExerciseChange}
                  placeholder={t("updateForm.exerciseName")}
                  className={`update-form-input${errorField === "name" ? " update-form-error" : ""}`}
                />
              </div>
              <div>
                <label className="update-form-field-label" htmlFor="update-form-per-link">{t("updateForm.perLink")}</label>
                <input
                  id="update-form-per-link"
                  type="text"
                  name="per_link"
                  value={exerciseData.per_link}
                  onChange={handleExerciseChange}
                  placeholder={t("updateForm.perLink")}
                  className="update-form-input"
                />
              </div>
              <div className="update-form-checkbox-container">
                <div>
                  <input
                    type="checkbox"
                    name="isfrench"
                    id="update-form-isfrench"
                    checked={exerciseData.isfrench}
                    onChange={handleExerciseChange}
                    className="update-form-checkbox"
                  />
                  <label htmlFor="update-form-isfrench">{t("updateForm.isFrench")}</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    name="isarabic"
                    id="update-form-isarabic"
                    checked={exerciseData.isarabic}
                    onChange={handleExerciseChange}
                    className="update-form-checkbox"
                  />
                  <label htmlFor="update-form-isarabic">{t("updateForm.isArabic")}</label>
                </div>
              </div>
              <div>
                <label className="update-form-field-label">{t("updateForm.helpImage")}</label>
                <label className="update-form-custom-file-input">
                  <span className="update-form-file-placeholder">
                    <span className="update-form-file-text">
                      {exerciseData.help_image
                        ? exerciseData.help_image instanceof File
                          ? exerciseData.help_image.name
                          : exerciseData.help_image.split("/").pop()
                        : t("updateForm.helpImage")}
                    </span>
                    <UploadIcon />
                  </span>
                  <input
                    type="file"
                    name="help_image"
                    ref={helpImageRef}
                    onChange={handleExerciseChange}
                    accept="image/jpeg,image/png,image/jpg,image/gif"
                    className="update-form-file-input"
                  />
                </label>
                {exerciseData.help_image && (
                  <div className="update-form-image-container">
                    <img
                      src={getImageUrl(exerciseData.help_image)}
                      alt={t("updateForm.helpImagePreview")}
                      className="update-form-preview-image"
                      onError={() =>
                        console.log("Failed to load help_image preview")
                      }
                    />
                    <div className="update-form-audio-wrapper">
                      <button
                        type="button"
                        onClick={() => handleDeleteFile("help_image")}
                        className="update-form-delete-button"
                        title={t("delete")}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>{t("delete")}</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label className="update-form-field-label">{t("updateForm.backgroundImageLabel")}</label>
                <div
                  onClick={() => setShowBackgroundSelector(true)}
                  className="update-form-file-placeholder"
                >
                  <span className="update-form-file-text">
                    {backgroundImageFile
                      ? backgroundImageFile.name
                      : exerciseData.background_image_path
                      ? exerciseData.background_image_path.split("/").pop()
                      : t("updateForm.backgroundImage")}
                  </span>
                  <UploadIcon />
                </div>
                {(backgroundImageFile || exerciseData.background_image_path) && (
                  <div className="update-form-image-container">
                    <img
                      src={getImageUrl(backgroundImageFile || exerciseData.background_image_path)}
                      alt={t("updateForm.backgroundPreview")}
                      className="update-form-preview-image"
                      onError={() =>
                        console.log("Failed to load background preview")
                      }
                    />
                    <div className="update-form-audio-wrapper">
                      <button
                        type="button"
                        onClick={() => handleDeleteFile("background_image")}
                        className="update-form-delete-button"
                        title={t("delete")}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>{t("delete")}</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label className="update-form-field-label" htmlFor="update-form-consigne">{t("updateForm.consigne")}</label>
                <input
                  id="update-form-consigne"
                  type="text"
                  name="consigne"
                  value={exerciseData.consigne}
                  onChange={handleExerciseChange}
                  placeholder={t("updateForm.consigne")}
                  className="update-form-input"
                />
              </div>
              <div>
                <label className="update-form-field-label">{t("updateForm.consigneAudio")}</label>
                <label className="update-form-custom-file-input">
                  <span className="update-form-file-placeholder">
                    <span className="update-form-file-text">
                      {exerciseData.consigne_audio
                        ? exerciseData.consigne_audio instanceof File
                          ? exerciseData.consigne_audio.name
                          : exerciseData.consigne_audio.split("/").pop()
                        : t("updateForm.consigneAudio")}
                    </span>
                    <UploadIcon />
                  </span>
                  <input
                    type="file"
                    name="consigne_audio"
                    ref={consigneAudioRef}
                    onChange={handleExerciseChange}
                    accept="audio/wav"
                    className="update-form-file-input"
                  />
                </label>
                {exerciseData.consigne_audio && (
                  <div className="update-form-audio-container">
                    <audio
                      controls
                      src={getImageUrl(exerciseData.consigne_audio)}
                      className="update-form-preview-audio"
                      onError={() =>
                        console.log("Failed to load consigne_audio preview")
                      }
                    />
                    <div className="update-form-audio-wrapper">
                      <button
                        type="button"
                        onClick={() => handleDeleteFile("consigne_audio")}
                        className="update-form-delete-button"
                        title={t("delete")}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>{t("delete")}</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label className="update-form-field-label">{t("updateForm.songAudio")}</label>
                <label className="update-form-custom-file-input">
                  <span className="update-form-file-placeholder">
                    <span className="update-form-file-text">
                      {exerciseData.song_audio
                        ? exerciseData.song_audio instanceof File
                          ? exerciseData.song_audio.name
                          : exerciseData.song_audio.split("/").pop()
                        : t("updateForm.songAudio")}
                    </span>
                    <UploadIcon />
                  </span>
                  <input
                    type="file"
                    name="song_audio"
                    ref={songAudioRef}
                    onChange={handleExerciseChange}
                    accept="audio/wav"
                    className="update-form-file-input"
                  />
                </label>
                {exerciseData.song_audio && (
                  <div className="update-form-audio-container">
                    <audio
                      controls
                      src={getImageUrl(exerciseData.song_audio)}
                      className="update-form-preview-audio"
                      onError={() =>
                        console.log("Failed to load song_audio preview")
                      }
                    />
                    <div className="update-form-audio-wrapper">
                      <button
                        type="button"
                        onClick={() => handleDeleteFile("song_audio")}
                        className="update-form-delete-button"
                        title={t("delete")}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>{t("delete")}</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="question-section">
              <h3 className="update-form-section-heading">{t("updateForm.questionDetailsSection")}</h3>
              {exerciseData.type !== "clavier_maths" &&
               exerciseData.type !== "clavier_langue" &&
               exerciseData.type !== "clavier2inputs" && (
                <>
                  <div>
                    <label className="update-form-field-label">{t("updateForm.choice1")}</label>
                    <input
                      type="text"
                      name="T1"
                      value={questionData.T1}
                      onChange={handleQuestionChange}
                      placeholder={t("updateForm.choice1")}
                      className={`update-form-input${errorField === "T1" ? " update-form-error" : ""}`}
                    />
                  </div>
                  {(exerciseData.type === "click" ||
                    exerciseData.type === "click_3_choix" ||
                    exerciseData.type === "click_4_choix" ||
                    exerciseData.type === "dropbox" ||
                    exerciseData.type === "dropbox_langue" ||
                    exerciseData.type === "click_3_phrase" ||
                    exerciseData.type === "click_4_phrase" ||
                    exerciseData.type === "drag_and_drop_phrase" ||
                    exerciseData.type === "drag_and_drop_paragraphe" ||
                    exerciseData.type === "quizz" ||
                    exerciseData.type === "click_phrase") && (
                    <div>
                      <label className="update-form-field-label">{t("updateForm.choice2")}</label>
                      <input
                        type="text"
                        name="T2"
                        value={questionData.T2}
                        onChange={handleQuestionChange}
                        placeholder={t("updateForm.choice2")}
                        className={`update-form-input${errorField === "T2" ? " update-form-error" : ""}`}
                      />
                    </div>
                  )}
                  {(exerciseData.type === "click_3_choix" ||
                    exerciseData.type === "click_4_choix" ||
                    exerciseData.type === "dropbox" ||
                    exerciseData.type === "dropbox_langue" ||
                    exerciseData.type === "click_3_phrase" ||
                    exerciseData.type === "click_4_phrase" ||
                    exerciseData.type === "drag_and_drop_phrase" ||
                    exerciseData.type === "drag_and_drop_paragraphe") && (
                    <div>
                      <label className="update-form-field-label">{t("updateForm.choice3")}</label>
                      <input
                        type="text"
                        name="T3"
                        value={questionData.T3}
                        onChange={handleQuestionChange}
                        placeholder={t("updateForm.choice3")}
                        className={`update-form-input${errorField === "T3" ? " update-form-error" : ""}`}
                      />
                    </div>
                  )}
                  {(exerciseData.type === "click_4_choix" ||
                    exerciseData.type === "click_4_phrase" ||
                    exerciseData.type === "drag_and_drop_phrase" ||
                    exerciseData.type === "drag_and_drop_paragraphe") && (
                    <div>
                      <label className="update-form-field-label">{t("updateForm.choice4")}</label>
                      <input
                        type="text"
                        name="T4"
                        value={questionData.T4}
                        onChange={handleQuestionChange}
                        placeholder={t("updateForm.choice4")}
                        className={`update-form-input${errorField === "T4" ? " update-form-error" : ""}`}
                      />
                    </div>
                  )}
                  {(exerciseData.type === "drag_and_drop_phrase" || exerciseData.type === "drag_and_drop_paragraphe") && (
                    <>
                      <div>
                        <label className="update-form-field-label">{t("updateForm.choice5")}</label>
                        <input
                          type="text"
                          name="T5"
                          value={questionData.T5}
                          onChange={handleQuestionChange}
                          placeholder={t("updateForm.choice5")}
                          className={`update-form-input${errorField === "T5" ? " update-form-error" : ""}`}
                        />
                      </div>
                      <div>
                        <label className="update-form-field-label">{t("updateForm.choice6")}</label>
                        <input
                          type="text"
                          name="T6"
                          value={questionData.T6}
                          onChange={handleQuestionChange}
                          placeholder={t("updateForm.choice6")}
                          className={`update-form-input${errorField === "T6" ? " update-form-error" : ""}`}
                        />
                      </div>
                    </>
                  )}
                </>
              )}
              {(exerciseData.type === "dropbox" ||
                exerciseData.type === "dropbox_langue" ||
                exerciseData.type === "click_phrase" ||
                exerciseData.type === "click_3_phrase" ||
                exerciseData.type === "click_4_phrase" ||
                exerciseData.type === "drag_and_drop_phrase" ||
                exerciseData.type === "drag_and_drop_paragraphe" ||
                exerciseData.type === "clavier_maths" ||
                exerciseData.type === "clavier_langue" ||
                exerciseData.type === "clavier2inputs" ||
                exerciseData.type === "quizz") && (
                <div>
                  <label className="update-form-field-label">
                    {exerciseData.type === "clavier_maths"
                      ? t("updateForm.mathExpression")
                      : t("updateForm.phrase")}
                  </label>
                  <input
                    type="text"
                    name="T7"
                    value={questionData.T7}
                    onChange={handleQuestionChange}
                    placeholder={
                      exerciseData.type === "clavier_maths"
                        ? t("updateForm.mathExpression")
                        : t("updateForm.phrase")
                    }
                    className={`update-form-input${errorField === "T7" ? " update-form-error" : ""}`}
                  />
                </div>
              )}
              {(exerciseData.type === "click_phrase" ||
                exerciseData.type === "click_3_phrase" ||
                exerciseData.type === "click_4_phrase" ||
                exerciseData.type === "dropbox" ||
                exerciseData.type === "dropbox_langue" ||
                exerciseData.type === "drag_and_drop_phrase" ||
                exerciseData.type === "drag_and_drop_paragraphe" ||
                exerciseData.type === "clavier2inputs" ||
                exerciseData.type === "quizz") && (
                <div>
                  <label className="update-form-field-label">{t("updateForm.correctPhrase")}</label>
                  <input
                    type="text"
                    name="T9"
                    value={questionData.T9}
                    onChange={handleQuestionChange}
                    placeholder={t("updateForm.correctPhrase")}
                    className={`update-form-input${errorField === "T9" ? " update-form-error" : ""}`}
                  />
                </div>
              )}
              {(exerciseData.type === "dropbox_langue" ||
                (!exerciseData.isfrench && !exerciseData.isarabic &&
                  (exerciseData.type === "dropbox" ||
                   exerciseData.type === "clavier_langue" ||
                   exerciseData.type === "click" ||
                   exerciseData.type === "click_3_choix" ||
                   exerciseData.type === "click_4_choix" ||
                   exerciseData.type === "click_phrase" ||
                   exerciseData.type === "click_3_phrase" ||
                   exerciseData.type === "click_4_phrase" ||
                   exerciseData.type === "drag_and_drop_phrase"))) && (
                <div>
                  <label className="update-form-field-label">{t("updateForm.frenchPhrase")}</label>
                  <input
                    type="text"
                    name="fr1"
                    value={questionData.fr1}
                    onChange={handleQuestionChange}
                    placeholder={t("updateForm.frenchPhrase")}
                    className={`update-form-input${errorField === "fr1" ? " update-form-error" : ""}`}
                  />
                </div>
              )}
              {(exerciseData.type === "click" ||
                exerciseData.type === "click_3_choix" ||
                exerciseData.type === "click_4_choix" ||
                exerciseData.type === "dropbox" ||
                exerciseData.type === "dropbox_langue" ||
                exerciseData.type === "clavier2inputs" ||
                exerciseData.type === "quizz") && (
                <div>
                  <label className="update-form-field-label">{t("updateForm.tableImage")}</label>
                  <label className="update-form-custom-file-input">
                    <span className="update-form-file-placeholder">
                      <span className="update-form-file-text">
                        {questionFiles[currentQuestionIndex]?.table4
                          ? questionFiles[currentQuestionIndex].table4.name
                          : questionData.table4
                          ? questionData.table4.split("/").pop()
                          : t("updateForm.tableImage")}
                      </span>
                      <UploadIcon />
                    </span>
                    <input
                      type="file"
                      name="table4"
                      ref={table4Ref}
                      onChange={handleQuestionChange}
                      accept="image/jpeg,image/png,image/jpg,image/gif"
                      className="update-form-file-input"
                    />
                  </label>
                  {(questionData.table4 ||
                    questionFiles[currentQuestionIndex]?.table4) && (
                    <div className="update-form-image-container">
                      <img
                        src={getImageUrl(
                          questionFiles[currentQuestionIndex]?.table4 ||
                            questionData.table4
                        )}
                        alt={t("updateForm.tableImagePreview")}
                        className="update-form-preview-image"
                        onError={() => console.log("Failed to load table4 preview")}
                      />
                      <div className="update-form-audio-wrapper">
                        <button
                          type="button"
                          onClick={() => handleDeleteFile("table4")}
                          className="update-form-delete-button"
                          title={t("delete")}
                        >
                          <FontAwesomeIcon icon="fa-solid fa-trash" />
                          <span>{t("delete")}</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div>
                <label className="update-form-field-label">{t("updateForm.phraseAudio")}</label>
                <label className="update-form-custom-file-input">
                  <span className="update-form-file-placeholder">
                    <span className="update-form-file-text">
                      {questionData.hmed_audio
                        ? questionData.hmed_audio instanceof File
                          ? questionData.hmed_audio.name
                          : questionData.hmed_audio.split("/").pop()
                        : t("updateForm.phraseAudio")}
                    </span>
                    <UploadIcon />
                  </span>
                  <input
                    type="file"
                    name="hmed_audio"
                    ref={hmedAudioRef}
                    onChange={handleQuestionChange}
                    accept="audio/wav"
                    className="update-form-file-input"
                  />
                </label>
                {questionData.hmed_audio && (
                  <div className="update-form-audio-container">
                    <audio
                      controls
                      src={getImageUrl(questionData.hmed_audio)}
                      className="update-form-preview-audio"
                      onError={() =>
                        console.log("Failed to load hmed_audio preview")
                      }
                    />
                    <div className="update-form-audio-wrapper">
                      <button
                        type="button"
                        onClick={() => handleDeleteFile("hmed_audio")}
                        className="update-form-delete-button"
                        title={t("delete")}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>{t("delete")}</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label className="update-form-field-label">{t("updateForm.correctPhraseAudio")}</label>
                <label className="update-form-custom-file-input">
                  <span className="update-form-file-placeholder">
                    <span className="update-form-file-text">
                      {questionData.Isac_audio
                        ? questionData.Isac_audio instanceof File
                          ? questionData.Isac_audio.name
                          : questionData.Isac_audio.split("/").pop()
                        : t("updateForm.correctPhraseAudio")}
                    </span>
                    <UploadIcon />
                  </span>
                  <input
                    type="file"
                    name="Isac_audio"
                    ref={IsacAudioRef}
                    onChange={handleQuestionChange}
                    accept="audio/wav"
                    className="update-form-file-input"
                  />
                </label>
                {questionData.Isac_audio && (
                  <div className="update-form-audio-container">
                    <audio
                      controls
                      src={getImageUrl(questionData.Isac_audio)}
                      className="update-form-preview-audio"
                      onError={() =>
                        console.log("Failed to load Isac_audio preview")
                      }
                    />
                    <div className="update-form-audio-wrapper">
                      <button
                        type="button"
                        onClick={() => handleDeleteFile("Isac_audio")}
                        className="update-form-delete-button"
                        title={t("delete")}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>{t("delete")}</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {exerciseData.type === "clavier2inputs" && (
                <div>
                  <label className="update-form-field-label">{t("updateForm.finalPhrase")}</label>
                  <input
                    type="text"
                    name="phrase_finale"
                    value={questionData.phrase_finale || ""}
                    onChange={handleQuestionChange}
                    placeholder={t("updateForm.finalPhrase")}
                    className="update-form-input"
                  />
                </div>
              )}
              {exerciseData.type !== "clavier2inputs" && (
                <div>
                  <label className="update-form-field-label">{t("updateForm.correctChoice")}</label>
                  <input
                    type="text"
                    name="reponse"
                    value={questionData.reponse || ""}
                    onChange={handleQuestionChange}
                    placeholder={t("updateForm.correctChoice")}
                    className={`update-form-input${errorField === "reponse" ? " update-form-error" : ""}`}
                  />
                </div>
              )}
              {exerciseData.type === "clavier2inputs" && (
                <>
                  <div>
                    <label className="update-form-field-label">{t("updateForm.firstCorrectAnswer")}</label>
                    <input
                      type="text"
                      name="reponse1"
                      value={questionData.reponse1 || ""}
                      onChange={handleQuestionChange}
                      placeholder={t("updateForm.firstCorrectAnswer")}
                      className={`update-form-input${errorField === "reponse1" ? " update-form-error" : ""}`}
                    />
                  </div>
                  <div>
                    <label className="update-form-field-label">{t("updateForm.secondCorrectAnswer")}</label>
                    <input
                      type="text"
                      name="reponse2"
                      value={questionData.reponse2 || ""}
                      onChange={handleQuestionChange}
                      placeholder={t("updateForm.secondCorrectAnswer")}
                      className={`update-form-input${errorField === "reponse2" ? " update-form-error" : ""}`}
                    />
                  </div>
                </>
              )}
            </div>
          )}
          <div className="update-form-button-container">
            <div className="update-form-button-group">
              <button
                type="button"
                onClick={handleBack}
                disabled={currentQuestionIndex === -1}
                className="update-form-button update-form-back-button-action"
              >
                {t("common.back")}
              </button>
              <button
                type="button"
                onClick={handleSave}
                disabled={isSubmitting}
                className="update-form-button update-form-save-button"
              >
                {isSubmitting ? t("updateForm.saving") : t("common.save")}
              </button>
              {currentQuestionIndex < MAX_QUESTIONS - 1 ? (
                <button
                  type="button"
                  onClick={handleNext}
                  className="update-form-button update-form-next-button"
                >
                  {t("common.next")}
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleSaveAndFinish}
                  disabled={isSubmitting}
                  className="update-form-button update-form-save-button"
                >
                  {isSubmitting ? t("updateForm.saving") : t("updateForm.saveFinish")}
                </button>
              )}
            </div>
          </div>
        </div>
        {showBackgroundSelector && (
          <BackgroundSelector
            onSelect={handleBackgroundSelect}
            onClose={() => setShowBackgroundSelector(false)}
          />
        )}
      </div>
    </div>
  );
};

export default UpdateForm;